var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNealand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318.62 603.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eyes{display:none;}.cls-nealand-1{fill:#c58167;}.cls-nealand-2{clip-path:url(#clip-nealand-path);}.cls-nealand-3{fill:#b6765f;}.cls-nealand-4{fill:#141519;}.cls-nealand-5{fill:#020205;}.cls-nealand-6{fill:#fbf4f4;}.cls-nealand-7{fill:#22232b;}.cls-nealand-8{fill:#040808;}.cls-nealand-9{fill:#a95f5b;}.cls-nealand-10{fill:#a0554c;}.cls-nealand-11{fill:#fff;}.cls-nealand-12{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-nealand-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-1",
    d: "M237.1,163.8s-7.79,18.68-11.84,63.66l-6,15.73-80.06-46.41L140,178.3l102.89-55.57Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-1",
    d: "M237.1,163.8s-7.79,18.68-11.84,63.66l-6,15.73-80.06-46.41L140,178.3l102.89-55.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-nealand-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-3",
    d: "M141.76,55.3S127.46,70,120.43,97.23s-2.71,25.4-5.8,35,6.91,44.15,13.44,55.86,11,24.17,31.82,24S218,183.8,230.05,158.89s9.75-50.81,9.75-50.81-4.69-65.36-27.13-67.33S141.76,55.3,141.76,55.3Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-nealand-4",
    points: "313.02 518.59 279.81 569.85 275.76 515.97 313.02 518.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-5",
    d: "M128.29,32.68S97,84,115.25,102.48s30-72.88,30-72.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-1",
    d: "M142.06,35.51s-14.31,14.67-21.34,41.92-2.71,25.41-5.79,35,6.9,44.14,13.44,55.86,11,24.17,31.81,24,58.08-28.36,70.17-53.27,9.74-50.8,9.74-50.8S235.4,22.93,213,21,142.06,35.51,142.06,35.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-4",
    d: "M129.82,171.18s35.05,41.36,50.24,69.73,63.62,151.61,63.62,151.61,10.6-29.81,10.6-35.25S241.1,219.7,241.1,219.7s48.75,26.46,58.18,44,2.36,72.41,2.36,82.18.16,35.55-6.86,57.24S271.49,488.9,276,506.76s12.12,98.56,9.25,116.1H24.29l2-20.91S-1.08,492.41,0,468.72s7.77-38.85,2.59-68.09-.37-77,4.44-98.8S23,221.52,51.84,223.37c0,0,46-18.6,60.74-28,0,0-1.07-2.84.62-4.8S127.71,177.44,129.82,171.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-6",
    d: "M230.05,191.13s10.91,10.45,10.68,17.16,4.2,36,4.2,36l12.55,86.82L259,370.29l-15.77,29.5L178.9,263l-35.34-74.23,40.75,23.14,32.7,21.5A135.47,135.47,0,0,0,226.47,216S226.72,210,230.05,191.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-7",
    d: "M129.82,171.18s-13.9,16-17.42,18.93-.09,5.66,2.86,11.15,11.75,20,11.75,20l16.9,10.37s-11.14,7-8.93,12.78S237,410.21,249.78,440s15.73,42.51,15.73,42.51,14-67.16,14-99.89-14.45-136.44-14.45-136.44L241.64,220l15.84,111.13L259,370.29l-15.77,29.5L143.56,188.73S133,182.29,129.82,171.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-8",
    d: "M223.25,241.78a12.57,12.57,0,0,0-7.8-.91S207.24,227,193,223.74c0,0-1.32,7.19-5.48,11.35s-6,19.77-6,19.77l8.72,15.81s21.39-14.8,24-14.6a39.4,39.4,0,0,0,9.94.51,31.66,31.66,0,0,0,20.4,16.82s13.38-16,13.38-22.1-.44-26.47-.44-26.47S232.91,228.63,223.25,241.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-nealand-8",
    cx: 221.65,
    cy: 285.73,
    rx: 2.29,
    ry: 3.08,
    transform: "translate(-47.59 44.32) rotate(-10.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-nealand-8",
    cx: 232.64,
    cy: 359.01,
    rx: 2.29,
    ry: 3.08,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -60.53, 47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-3",
    d: "M314.08,408.3c-2.46-4.18-17-12.18-17-12.18S288.61,379,283.19,379.5s-9,3.94-13.17,4.19-2.46,9.6,1.85,10.33C271.87,394,316.54,412.48,314.08,408.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-1",
    d: "M279.71,462.39l-3.15,19.33s17.73,22.85,24,27.84l5.64-33.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-6",
    d: "M277.14,477.21s12.63,18.32,25.56,18l3.51-19.59s7.52,3.54,8.3,18.36,3.39,31.07-11.17,32.35S275.76,516,275.76,516,265.63,485.57,277.14,477.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-9",
    d: "M138.13,155.8s-3,3.41-1.17,6,6.08,5.45,15.9,5.13,14.89-11.69,18.22-13.53C171.08,153.37,141.87,152,138.13,155.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-5",
    d: "M118.68,35.87s19.6-2.17,26.93,3,39.41-10.1,44.16-10.7,24.56,2.38,22.18,8.32S196.7,67.36,200.66,71.12s19,6.34,19.21,47.73L226.8,120s.2-22.38,12.68-16.64c0,0-4.16,56.84-2.38,60.4s11.09-13.26,15.25-25.15,23.14-54,11.54-78.23S243.33,36.7,243.33,36.7,239,15.47,217.1,10.22s-52-7.08-57.58-9.51c-7.8-3.36-18.7,6.33-27.57,5s3.23,14.8,3.23,14.8-11.57,1.88-15.74,4.84,3.9,2.42,3.9,2.42S115.77,33.24,118.68,35.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-1",
    d: "M230.9,107.05a15.34,15.34,0,0,1,10.41-11.22,13.56,13.56,0,0,1,12,2.15c11.37,7.86-7.85,49.16-19.39,42.21C225.35,135,228.64,116.32,230.9,107.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-10",
    d: "M171.08,153.37s-10.26-3.3-15.86-5.5-6.63-.82-9.72-.93a14.59,14.59,0,0,0-8.43,2.56c-2.14,1.5-3.31,3.95-1.71,5.55s5,0,6.51.53a21.63,21.63,0,0,0,10.56.11C157.34,154.62,162.84,160.55,171.08,153.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-nealand-1",
    d: "M308.54,464.29s5.1-33.85,5.91-40.36c.77-6.16,2.09-11.45-.37-15.63s-17-12.18-17-12.18-18.89-3.78-25.23-2.1c0,0-15,1.85-7.88,15.14,0,0-8.12,2.95-6.52,10s5.42,5.78,5.42,5.78-6.52,2.83-4.19,9.23,6.65,5.05,6.65,5.05-6.77,2.83-3,8.86,13.9,23.26,20.55,26.46,22.39,3.44,23.26,1.1S308.54,464.29,308.54,464.29Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-nealand-11 eyeball",
    cx: 131.37,
    cy: 95.56,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-nealand-12 pupil",
    cx: 131.37,
    cy: 95.56,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-nealand-11 eyeball",
    cx: 176.59,
    cy: 98.48,
    r: 12.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-nealand-12 pupil",
    cx: 176.59,
    cy: 98.48,
    r: 8.01
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNealand);
export default __webpack_public_path__ + "static/media/Nealand.939915139ca27670dd33ad7150c75a8d.svg";
export { ForwardRef as ReactComponent };